<template>
  <div class="main">
    <div class="navbar">
      <a href="https://tupibox.com/" target="_blank"
        ><img src="@/assets/logo.png" alt="logo"
      /></a>
    </div>
    <progress-bar :activeField="activeStep" :formLength="10"></progress-bar>
    <section class="section" style="padding-top: 0.5rem" v-if="configs">
      <b-steps v-model="activeStep" :animated="true" :has-navigation="false">
        <b-step-item>
          <step-zero></step-zero>
        </b-step-item>
        <b-step-item>
          <step-one></step-one>
        </b-step-item>
        <b-step-item>
          <step-two></step-two>
        </b-step-item>
        <b-step-item>
          <step-three></step-three>
        </b-step-item>
        <b-step-item>
          <step-four></step-four>
        </b-step-item>
        <b-step-item>
          <step-five></step-five>
        </b-step-item>
        <!-- <b-step-item>
              <step-select-box-size></step-select-box-size>
          </b-step-item> -->
        <b-step-item>
          <step-six></step-six>
        </b-step-item>
        <b-step-item>
          <extra-toy></extra-toy>
        </b-step-item>
        <b-step-item>
          <step-seven></step-seven>
        </b-step-item>
        <b-step-item>
          <step-checkout></step-checkout>
        </b-step-item>
      </b-steps>
    </section>
    <div class="loading" v-else>
      <loader></loader>
    </div>
    <div class="footerSteps">
      TupiBox 🐾 Desde 2020 entregando amor a los perritos y conectándolos con sus dueñas(os)<br>
      <small style="opacity: 0.7;">Marca de Inversiones ECP SpA</small>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Loader from "./Loader.vue";
import StepSelectBoxSize from "./steps/StepSelectBoxSize.vue";
import ProgressBar from "./ProgressBar.vue";
import StepZero from "./steps/StepZero.vue";
import StepOne from "./steps/StepOne.vue";
import StepTwo from "./steps/StepTwo.vue";
import StepThree from "./steps/StepThree.vue";
import StepFour from "./steps/StepFour.vue";
import StepFive from "./steps/StepFive.vue";
import StepSix from "./steps/StepSix.vue";
import StepSeven from "./steps/StepSeven.vue";
import StepCheckout from "./steps/StepCheckout.vue";
import ExtraToy from "./steps/ExtraToy.vue";
import WhatsAppButton from "./WhatsAppButton.vue";

export default {
  name: "Steps",
  components: {
    StepZero,
    StepOne,
    StepTwo,
    StepThree,
    StepFour,
    StepFive,
    StepSix,
    StepSeven,
    StepCheckout,
    ExtraToy,
    ProgressBar,
    StepSelectBoxSize,
    Loader,
    WhatsAppButton,
  },
  data() {
    return {
      activeStep: 0,
      cuponEventAdded: false,
      formData: {
        allergie: "",
      },
      configs: {
        // TupiBox Fresh - Configs locales (sin webhook)
        breeds: [
          "Mestizo",
          "Labrador Retriever",
          "Golden Retriever",
          "Pastor Alemán",
          "Bulldog Francés",
          "Beagle",
          "Poodle",
          "Yorkshire Terrier",
          "Chihuahua",
          "Boxer",
          "Husky Siberiano",
          "Dálmata",
          "Pug",
          "Shih Tzu",
          "Schnauzer",
          "Cocker Spaniel",
          "Border Collie",
          "Doberman",
          "Gran Danés",
          "Rottweiler",
          "Bulldog Inglés",
          "Pomerania",
          "Maltés",
          "Corgi",
          "Shiba Inu"
        ],
        prices: {
          // Precios TupiBox Fresh (comida) - TESTING $1000
          // Pequeño 5kg
          fresh_small_5kg_x1: 1000,
          fresh_small_5kg_x3: 1000,
          fresh_small_5kg_x6: 1000,
          // Mediano 10kg
          fresh_medium_10kg_x1: 1000,
          fresh_medium_10kg_x3: 1000,
          fresh_medium_10kg_x6: 1000,
          // Grande 20kg
          fresh_large_20kg_x1: 1000,
          fresh_large_20kg_x3: 1000,
          fresh_large_20kg_x6: 1000,
          // Gigante 35kg
          fresh_giant_35kg_x1: 1000,
          fresh_giant_35kg_x3: 1000,
          fresh_giant_35kg_x6: 1000,
          // Extra Fresh (Snacks saludables)
          extra_snacks: 9990,
          
          // TupiBox Original (Juguetes y Snacks) - Precios reales
          light_x1: 29990,  // Mismo precio que normal (solo hay un tamaño ahora)
          light_x3: 27990,
          light_x6: 24990,
          normal_x1: 29990,
          normal_x3: 27990,
          normal_x6: 24990,
          extratoy: 9990
        }
      },
    };
  },
  computed: {},
  methods: {
    // Guardar datos del formulario en localStorage
    saveFormData() {
      try {
        localStorage.setItem('tupibox_form_data', JSON.stringify(this.formData));
        localStorage.setItem('tupibox_active_step', this.activeStep.toString());
        console.log('✅ Formulario guardado en localStorage');
      } catch (e) {
        console.error('Error guardando en localStorage:', e);
      }
    },
    
    // Cargar datos guardados
    loadFormData() {
      try {
        const savedData = localStorage.getItem('tupibox_form_data');
        const savedStep = localStorage.getItem('tupibox_active_step');
        
        if (savedData) {
          this.formData = JSON.parse(savedData);
          console.log('✅ Datos restaurados desde localStorage');
        }
        
        if (savedStep) {
          this.activeStep = parseInt(savedStep);
          console.log(`✅ Paso ${this.activeStep} restaurado`);
        }
      } catch (e) {
        console.error('Error cargando desde localStorage:', e);
      }
    },
    
    // Limpiar datos guardados (al completar compra exitosa)
    clearFormData() {
      try {
        localStorage.removeItem('tupibox_form_data');
        localStorage.removeItem('tupibox_active_step');
        console.log('✅ Datos del formulario limpiados');
      } catch (e) {
        console.error('Error limpiando localStorage:', e);
      }
    },
    
    nextStep(payload) {
      function addEvent(obj, evt, fn) {
          if (obj.addEventListener) {
              obj.addEventListener(evt, fn, false);
          } else if (obj.attachEvent) {
              obj.attachEvent("on" + evt, fn);
          }
      }
      function removeEvent(obj, evt, fn) {
          if (obj.addEventListener) {
              obj.removeEventListener(evt, fn, false);
          }
      }
      // Exit popup desactivado - no medible ni efectivo
      // function evnt(evt) {
      //     if (evt.toElement == null && evt.relatedTarget == null) {
      //       console.log(this.activeStep);
      //       exitPopup.classList.add('show');
      //       removeEvent(document, 'mouseout', evnt);
      //     }
      // }
      this.activeStep = this.activeStep + 1;
      // StepFive ya NO se salta - ahora muestra alergias para todos los tipos
      // Exit popup desactivado
      // if (this.activeStep == 9 && this.cuponEventAdded == false) {
      //   addEvent(document, 'mouseout', evnt);
      //   this.cuponEventAdded = true;
      // }
      
      // Guardar después de cada paso
      this.saveFormData();
    },
    backStep(payload) {
      this.activeStep = this.activeStep - 1;
      // StepFive ya NO se salta - ahora muestra alergias para todos los tipos
      
      // Guardar también al retroceder
      this.saveFormData();
    },
  },
  created() {
    // ⚡ CARGAR PARÁMETROS ANTES DE MONTAR COMPONENTES
    // Esto asegura que formData esté listo cuando StepSix se monte
    console.log("✅ TupiBox Fresh - Cargando parámetros...");
    
    // Capturar URL y parámetros UTM
    const urlParams = new URLSearchParams(window.location.search);
    this.formData.url = window.location.href;
    this.formData.utm_source = urlParams.get('utm_source') || '';
    this.formData.utm_medium = urlParams.get('utm_medium') || '';
    this.formData.utm_campaign = urlParams.get('utm_campaign') || '';
    this.formData.utm_content = urlParams.get('utm_content') || '';
    this.formData.utm_term = urlParams.get('utm_term') || '';
    
    // ✨ PRE-LLENAR CAMPOS DEL FORMULARIO DESDE QUERY PARAMS
    // Integración con bot de WhatsApp para reducir fricción
    console.log('🔍 Verificando parámetros de pre-llenado...');
    
    // STEP ONE: Sexo y nombre del perro
    if (urlParams.get('sex')) {
      this.formData.sex = urlParams.get('sex'); // 'He' | 'She'
      console.log('✅ Sexo pre-llenado:', this.formData.sex);
    }
    if (urlParams.get('petname')) {
      this.formData.petname = urlParams.get('petname');
      console.log('✅ Nombre pre-llenado:', this.formData.petname);
    }
    
    // STEP TWO: Peso
    if (urlParams.get('weight')) {
      this.formData.weight = parseFloat(urlParams.get('weight'));
      console.log('✅ Peso pre-llenado:', this.formData.weight);
    }
    
    // STEP THREE: Raza
    if (urlParams.get('breed')) {
      this.formData.breed = urlParams.get('breed');
      console.log('✅ Raza pre-llenada:', this.formData.breed);
    }
    
    // STEP FOUR: Fecha de nacimiento o edad
    if (urlParams.get('birth')) {
      this.formData.birth = new Date(urlParams.get('birth'));
      console.log('✅ Fecha nacimiento pre-llenada:', this.formData.birth);
    } else if (urlParams.get('ageInMonths')) {
      this.formData.ageInMonths = parseInt(urlParams.get('ageInMonths'));
      console.log('✅ Edad pre-llenada:', this.formData.ageInMonths, 'meses');
    }
    
    // STEP FIVE: Alimentación y alergias
    if (urlParams.get('proteinPreference')) {
      this.formData.proteinPreference = urlParams.get('proteinPreference');
      console.log('✅ Proteína pre-llenada:', this.formData.proteinPreference);
    }
    if (urlParams.get('currentFood')) {
      this.formData.currentFood = urlParams.get('currentFood');
      console.log('✅ Comida actual pre-llenada:', this.formData.currentFood);
    }
    if (urlParams.get('activityLevel')) {
      this.formData.activityLevel = urlParams.get('activityLevel'); // 'Bajo', 'Medio', 'Alto'
      console.log('✅ Actividad pre-llenada:', this.formData.activityLevel);
    }
    if (urlParams.get('allergie')) {
      this.formData.allergie = urlParams.get('allergie');
      console.log('✅ Alergias pre-llenadas:', this.formData.allergie);
    }
    
    // STEP SEVEN: Email y teléfono
    if (urlParams.get('email')) {
      this.formData.email = urlParams.get('email');
      console.log('✅ Email pre-llenado:', this.formData.email);
    }
    if (urlParams.get('phone')) {
      this.formData.phone = urlParams.get('phone');
      console.log('✅ Teléfono pre-llenado:', this.formData.phone);
    }
    
    // Tipo de producto
    if (urlParams.get('product_type')) {
      this.formData.product_type = urlParams.get('product_type');
      console.log('✅ Tipo producto pre-llenado:', this.formData.product_type);
    }
    
    // ✨ Si viene con datos pre-llenados desde bot, saltar al Step 6 (selección de plan)
    const hasPrefilledData = urlParams.get('petname') && urlParams.get('weight') && urlParams.get('breed');
    const fromBot = urlParams.get('utm_medium') === 'bot';
    
    if (hasPrefilledData && fromBot) {
      console.log('🤖 Datos pre-llenados desde bot detectados - Saltando a selección de plan (Step 6)');
      this.activeStep = 6; // StepSix (selección de plan y frecuencia)
      
      // Mostrar notificación al usuario
      this.$buefy.toast.open({
        message: `✅ Datos de ${this.formData.petname} cargados desde WhatsApp`,
        type: 'is-success',
        duration: 4000,
        position: 'is-top'
      });
    } else if (hasPrefilledData) {
      console.log('📋 Datos pre-llenados detectados (no desde bot)');
    }
    
    // Cargar datos guardados del formulario solo si NO hay pre-llenado
    if (!hasPrefilledData) {
      this.loadFormData();
    }
  },
  
  async mounted() {
    // Configs completamente locales para performance
    console.log("✅ TupiBox Fresh cargado - Configs locales");
  },
  
  // Guardar datos cuando el usuario cierra/recarga la página
  beforeDestroy() {
    this.saveFormData();
  },
};
</script>
